(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "react", "reactDOM"], factory);
	else if(typeof exports === 'object')
		exports["productWidget"] = factory(require("lodash"), require("react"), require("react-dom"));
	else
		root["productWidget"] = factory(root["_"], root["React"], root["ReactDOM"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__484__, __WEBPACK_EXTERNAL_MODULE__7762__, __WEBPACK_EXTERNAL_MODULE__8677__) {
return 